module.exports = __webpack_public_path__ + "img/cont1.6bfc75e2.jpg";